import { Injectable } from '@angular/core';
import { EnablePowerDmsApiModel, PowerDmsAddOnApiModel } from '@app/api/api-models';
import { Observable } from 'rxjs';
import { AddOnService } from '../../abstractions/add-on.service';

@Injectable()
export class PowerDmsAddOnService extends AddOnService<PowerDmsAddOnApiModel> {
  public readonly prefix = 'power-dms';

  public changeMode(isActive: boolean): Observable<unknown> {
    return this.http.patch<unknown>(
      `${this.apiUrl}${this.prefix}/site-integration`,
      new EnablePowerDmsApiModel(isActive)
    );
  }
}
